// import { AiFillPlusCircle, AiOutlineLoading } from "react-icons/ai";
// import { BiSolidEditAlt } from "react-icons/bi";
// import { useRef, useState, useEffect } from "react";

// const UploadImage = ({ imageUrl, setImageUrl, onImageUpload }) => {
//   const fileInputRef = useRef();
//   const [imageError, setImageError] = useState(false);
//   const [imageLoading, setImageLoading] = useState(false);

//   const beforeUpload = (file, maxFileSize = 2) => {
//     const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
//     if (!isJpgOrPng) {
//       setImageError(true);
//       return false;
//     }

//     const isLt2M = file.size / 1024 / 1024 < maxFileSize;
//     if (!isLt2M) {
//       setImageError(true);
//       return false;
//     }

//     return true;
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file && beforeUpload(file)) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setImageUrl(reader.result);
//         setImageLoading(false);
//       };
//       setImageLoading(true);
//       reader.readAsDataURL(file);

//       onImageUpload(file); // for upload to server or parent component
//     }
//   };

//   useEffect(() => {
//     if (imageError) {
//       setImageLoading(false);
//     }
//   }, [imageError]);

//   return (
//     <div className="relative w-[120px] mb-3">
//       <h2>Click to upload </h2>
//       <div
//         onClick={() => fileInputRef.current.click()}
//         className="cursor-pointer w-[120px] h-[120px] border-2 border-white bg-no-repeat bg-gray-300 bg-cover bg-center flex items-center justify-center text-primary"
//         style={{
//           backgroundImage: `url('${imageUrl || "/images/dummy.jpeg"}')`,
//         }}
//       >
//         {imageLoading && (
//           <AiOutlineLoading className="inline animate-spin text-3xl" />
//         )}
//       </div>
//       <button
//         onClick={() => fileInputRef.current.click()}
//         className="absolute w-[40px] h-[40px] border-2 border-white rounded-full bg-primary bottom-0 right-0 md:-right-2 flex items-center justify-center text-white text-[20px]"
//       >
//         {imageUrl ? (
//           <BiSolidEditAlt className="text-black" />
//         ) : (
//           <AiFillPlusCircle className="text-black" />
//         )}
//       </button>
//       <input
//         type="file"
//         accept="image/jpeg,image/png"
//         onChange={handleFileChange}
//         ref={fileInputRef}
//         className="hidden"
//       />
//     </div>
//   );
// };

// export default UploadImage;

// import { AiFillPlusCircle, AiOutlineLoading } from "react-icons/ai";
// import { BiSolidEditAlt } from "react-icons/bi";
// import { useRef, useState, useEffect } from "react";

// const UploadImage = ({ imageUrl, setImageUrl, onImageUpload }) => {
//   const fileInputRef = useRef();

//   const [previewUrl, setPreviewUrl] = useState("");
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [uploading, setUploading] = useState(false);
//   const [error, setError] = useState(false);
//   const [successMessage, setSuccessMessage] = useState("");

//   const beforeUpload = (file, maxFileSize = 2) => {
//     const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
//     const isLt2M = file.size / 1024 / 1024 < maxFileSize;

//     if (!isJpgOrPng || !isLt2M) {
//       setError(true);
//       console.warn("Only JPG/PNG images under 2MB are allowed.");
//       return false;
//     }

//     setError(false);
//     return true;
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file && beforeUpload(file)) {
//       console.log("File selected:", file.name);
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setPreviewUrl(reader.result);
//         setSelectedFile(file);
//         setSuccessMessage("");
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleUpload = async () => {
//     if (!selectedFile) return;

//     console.log("Uploading...");
//     setUploading(true);
//     setError(false);
//     setSuccessMessage("");

//     try {
//       const uploadedUrl = await onImageUpload(selectedFile);
//       if (uploadedUrl) {
//         console.log("Upload successful! URL:", uploadedUrl);
//         setImageUrl(uploadedUrl);
//         setPreviewUrl("");
//         setSelectedFile(null);
//         setSuccessMessage("Image uploaded successfully.");
//       } else {
//         console.warn("Upload completed but no URL returned.");
//       }
//     } catch (err) {
//       console.error("Upload failed:", err);
//       setError(true);
//     } finally {
//       setUploading(false);
//     }
//   };

//   return (
//     <div className="flex items-start gap-4 mb-3">
//       {/* Image Preview */}
//       <div className="relative w-[120px]">
//         <h2>Click to upload</h2>
//         <div
//           onClick={() => fileInputRef.current.click()}
//           className="cursor-pointer w-[120px] h-[120px] border-2 border-white bg-no-repeat bg-gray-300 bg-cover bg-center flex items-center justify-center text-primary"
//           style={{
//             backgroundImage: `url('${
//               previewUrl || imageUrl || "/images/dummy.jpeg"
//             }')`,
//           }}
//         >
//           {uploading && (
//             <AiOutlineLoading className="inline animate-spin text-3xl" />
//           )}
//         </div>

//         {/* Add/Edit Icon */}
//         <button
//           onClick={() => fileInputRef.current.click()}
//           type="button"
//           className="absolute w-[40px] h-[40px] border-2 border-white rounded-full bg-primary bottom-0 right-0 md:-right-2 flex items-center justify-center text-white text-[20px]"
//         >
//           {imageUrl || previewUrl ? (
//             <BiSolidEditAlt className="text-black" />
//           ) : (
//             <AiFillPlusCircle className="text-black" />
//           )}
//         </button>

//         {/* Hidden File Input */}
//         <input
//           type="file"
//           accept="image/jpeg,image/png"
//           onChange={handleFileChange}
//           ref={fileInputRef}
//           className="hidden"
//         />
//       </div>

//       {/* Upload Button and Messages */}
//       <div className="flex flex-col justify-start">
//         {selectedFile && !uploading && (
//           <button
//             onClick={handleUpload}
//             type="button"
//             className="px-4 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm"
//           >
//             Upload
//           </button>
//         )}

//         {successMessage && (
//           <p className="text-green-600 text-sm mt-2">{successMessage}</p>
//         )}

//         {error && (
//           <p className="text-red-600 text-sm mt-2">
//             Upload failed or invalid file. Only JPG/PNG under 2MB.
//           </p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default UploadImage;



import { AiFillPlusCircle, AiOutlineLoading } from "react-icons/ai";
import { BiSolidEditAlt } from "react-icons/bi";
import { useRef, useState } from "react";

const UploadImage = ({ imageUrl, setImageUrl, onImageUpload }) => {
  const fileInputRef = useRef();
  const [previewUrl, setPreviewUrl] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      console.log("File selected:", file.name);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
        setSelectedFile(file);
        setSuccessMessage("");
        setError("");
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) return;

    console.log("Uploading:", selectedFile.name);
    setUploading(true);
    setError("");
    setSuccessMessage("");

    try {
      const uploadedUrl = await onImageUpload(selectedFile);
      if (uploadedUrl) {
        console.log("Upload successful! URL:", uploadedUrl);
        setImageUrl(uploadedUrl);
        setPreviewUrl("");
        setSelectedFile(null);
        setSuccessMessage("Image uploaded successfully.");
      } else {
        console.warn("Upload completed but no URL returned.");
        setError("Upload completed but no URL returned.");
      }
    } catch (err) {
      console.error("Upload error:", err);
      setError(err.response?.data?.message || "Failed to upload image.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="flex items-start gap-4 mb-3">
      {/* Image Preview */}
      <div className="relative w-[120px]">
        <h2>Click to upload</h2>
        <div
          onClick={() => fileInputRef.current.click()}
          className="cursor-pointer w-[120px] h-[120px] border-2 border-white bg-no-repeat bg-gray-300 bg-cover bg-center flex items-center justify-center text-primary"
          style={{
            backgroundImage: `url('${
              previewUrl || (imageUrl && typeof imageUrl === "string" ? imageUrl : "/images/dummy.jpeg")
            }')`,
          }}
        >
          {uploading && (
            <AiOutlineLoading className="inline animate-spin text-3xl" />
          )}
        </div>

        {/* Add/Edit Icon */}
        <button
          onClick={() => fileInputRef.current.click()}
          type="button"
          className="absolute w-[40px] h-[40px] border-2 border-white rounded-full bg-primary bottom-0 right-0 md:-right-2 flex items-center justify-center text-white text-[20px]"
        >
          {imageUrl || previewUrl ? (
            <BiSolidEditAlt className="text-black" />
          ) : (
            <AiFillPlusCircle className="text-black" />
          )}
        </button>

        {/* Hidden File Input */}
        <input
          type="file"
          accept="*/*" // Allow all file types
          onChange={handleFileChange}
          ref={fileInputRef}
          className="hidden"
        />
      </div>

      {/* Upload Button and Messages */}
      <div className="flex flex-col justify-start">
        {selectedFile && !uploading && (
          <button
            onClick={handleUpload}
            type="button"
            className="px-4 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm"
          >
            Upload
          </button>
        )}

        {successMessage && (
          <p className="text-green-600 text-sm mt-2">{successMessage}</p>
        )}

        {error && (
          <p className="text-red-600 text-sm mt-2">{error}</p>
        )}
      </div>
    </div>
  );
};

export default UploadImage;